import axios from 'axios';
import { buildDressDeclarationPlaceholders } from './dressDeclarationPlaceholders';
import { formatDateForDeclarationPrint } from './printDressDeclaration';
import { replacePlaceholders, openBulkPrintDocument } from './printDocument';

export async function printBulkDressDeclarations({
  salonId,
  templateId,
  dresses,
  paperSize,
  t,
  formatPrice,
  getMonthName,
  salonSlug
}) {
  const token = localStorage.getItem('token');
  const response = await axios.get(`/api/salons/${salonId}/declarations/${templateId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  const declaration = response.data.declaration || response.data;
  const content = declaration.declaration_content;

  if (!content) {
    throw new Error(t('messages.error.declarationTemplateNoContent', 'Declaration template has no content'));
  }

  const formatDate = (dateString) => formatDateForDeclarationPrint(dateString, getMonthName);

  const items = [];
  for (const dress of dresses) {
    const placeholderMap = await buildDressDeclarationPlaceholders(dress, { t, formatPrice, formatDate, salonSlug });
    items.push(replacePlaceholders(content, placeholderMap));
  }

  openBulkPrintDocument({
    title: declaration.title || t('dresses.printDeclarations', 'Print declarations'),
    items,
    itemWidthCm: Number(declaration.page_width) || 7,
    itemHeightCm: Number(declaration.page_height) || 5,
    paperSize,
    contentClass: 'declaration-content'
  });
}
